import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import Button from '../button/Button';
import { schedulePage } from '../../utils';

const AppLinksOverlay = ({ playStoreLink, appStoreLink, resortMessage, setShowAppModal }) => {
  const history = useHistory();
  return (
    <div className="alert overlay linksoverlay">
      <div>{resortMessage}</div>
      <div>
        Play store link:
        {' '}
        <a
          href={playStoreLink}
          target="_blank"
          rel="noopener noreferrer"
        >

          {playStoreLink}
        </a>
      </div>
      <div>
        App store link:
        {' '}
        <a
          href={appStoreLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          {appStoreLink}
        </a>
      </div>
      <div>
        <Button
          type="button"
          className="positive-button"
          text="OK"
          onClick={() => {
            setShowAppModal(false);
            history.push(schedulePage);
          }}
        />
      </div>
    </div>
  );
};

AppLinksOverlay.propTypes = {
  playStoreLink: PropTypes.string,
  appStoreLink: PropTypes.string,
  resortMessage: PropTypes.string,
  setShowAppModal: PropTypes.func,
};

export default AppLinksOverlay;
